import axios from 'axios';

const baseDomain = import.meta.env.VITE_API_URL;
const userLanguage = localStorage.getItem('userLanguage');

// Paket expired mesajının sadece bir kez gösterilmesi için flag
let packageExpiredSnackbarShown = false;

// Sayfa değişikliklerinde bekleyen istekleri iptal etmek için
const pendingControllers = new Set();

export function cancelPendingRequests() {
    pendingControllers.forEach((controller) => {
        controller.abort();
    });
    pendingControllers.clear();
}

const instance = axios.create({
    baseURL: baseDomain,
    headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Accept-Language": userLanguage,
    },
});

instance.interceptors.request.use(
    (config) => {
        const clientToken = localStorage.getItem('clientToken');
        const authToken = localStorage.getItem('authToken');

        if (authToken) {
            config.headers.Authorization = `Bearer ${authToken}`;
        } else if (clientToken) {
            config.headers.Authorization = `Bearer ${clientToken}`;
        }

        // Auth isteklerini iptal mekanizmasından hariç tut
        const isAuthRequest = config.url && (
            config.url.includes('/login') ||
            config.url.includes('/clientToken') ||
            config.url.includes('/logout')
        );

        if (!config.signal && !isAuthRequest) {
            const controller = new AbortController();
            config.signal = controller.signal;
            config._abortController = controller;
            pendingControllers.add(controller);
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    async (response) => {
        // Tamamlanan isteği listeden kaldır
        if (response.config._abortController) {
            pendingControllers.delete(response.config._abortController);
        }

        if (response?.data.error_code === 'PACKAGE_EXPIRED') {

            window.location.href = '/billing';
        }

        return Promise.resolve(response);
    },
    async (error) => {
        // Tamamlanan/iptal edilen isteği listeden kaldır
        if (error.config?._abortController) {
            pendingControllers.delete(error.config._abortController);
        }

        // İptal edilen istekleri sessizce yoksay, catch'e düşmez
        if (axios.isCancel(error)) {
            return new Promise(() => {});
        }
        if ((error.response?.data.error_code === 'PACKAGE_EXPIRED' || error.response?.data.error_code === 'DEMO_EXPIRED') && window.location.pathname !== '/billing') {
            window.location.href = '/billing';
        }
        if (error.response?.status === 403) {

            //window.location.href = '/401';
        }

        if (error.response?.status === 401) {
            localStorage.removeItem('authToken');
            window.location.href = '/login';
        }

        if ((error.response?.data.error_code === 'PACKAGE_EXPIRED' || error.response?.data.error_code === 'DEMO_EXPIRED')) {
            // Sadece bir kez göster
            if (!packageExpiredSnackbarShown) {
                packageExpiredSnackbarShown = true;
                const message = error.response.data.message || 'Paket süreniz dolmuştur.';

                window.dispatchEvent(new CustomEvent('showPackageExpiredSnackbar', {
                    detail: { message }
                }));

                // 5 saniye sonra flag'i sıfırla (sayfa geçişlerinde tekrar gösterilebilsin)
                setTimeout(() => {
                    packageExpiredSnackbarShown = false;
                }, 5000);
            }
        }

        return Promise.reject(error);
    }
);

export default instance;
